export default __webpack_public_path__ + "static/media/Alchemist-Bundles.ea0adc09.png";